import React,{useRef} from 'react';
import emailjs from '@emailjs/browser';
import swal from "sweetalert";

const NeedHelp = () => {
    const form = useRef();
	const sendEmail = (e) => {
		e.preventDefault();		
		emailjs.sendForm('service_gfykn6i', 'template_iy1pb0b', e.target, 'HccoOtZS6GHw-N-m6')
		  .then((result) => {
			  console.log(result.text);
		  }, (error) => {
			  console.log(error.text);
		  });
		  e.target.reset()
		  swal('Good job!', 'form successfuly submmited', "success");
	};
    return (
        <>
            <div className="row align-items-center">
                <div className="col-lg-3">
                    <div className="section-head wow fadeInUp" data-wow-delay="0.2s">
                        <h6 className="sub-title text-white">JOIN US</h6>
                        <h4 className="title text-white">We Need Your Help</h4>
                    </div>
                </div>
                <div className="col-lg-9">
                    <form className="dzForm" ref={form} onSubmit={sendEmail}>
                        <div className="dzFormMsg"></div>
                        <input type="hidden" className="form-control" name="dzToDo" value="Contact" />
                        <input type="hidden" className="form-control" name="reCaptchaEnable" value="0" />
                        
                        <div className="row g-4 m-b30">
                            <div className="col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="0.4s" >
                                <input name="dzFirstName" required="" type="text" className="form-control" placeholder="First Name" />
                            </div>
                            <div className="col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="0.6s" >
                                <input name="dzLastName" required="" type="text" className="form-control" placeholder="Last Name" />
                            </div>
                            <div className="col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="0.8s" >
                                <input name="dzEmail" required="" type="text" className="form-control" placeholder="Email Address" />
                            </div>
                            <div className="col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="1.0s" >
                                <input name="dzPhoneNumber" required="" type="number" className="form-control" placeholder="Phone Number" />
                            </div>
                            <div className="col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="1.2s">
                                <input name="dzMessage" required="" type="text" className="form-control" placeholder="Your Message" />
                            </div>
                            <div className="col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="1.4s" >
                                <button name="submit" type="submit" value="Submit" className="btn btn-dark btn-block w-100 h-100">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>   
        </>
    );
};

export default NeedHelp;